var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluefooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 70,
    viewBox: "0 0 249 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184 0H0V70H184V0Z",
    fill: "#032D45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207 0H196V70H207V0Z",
    fill: "#032D45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228 0H217V70H228V0Z",
    fill: "#032D45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249 0H238V70H249V0Z",
    fill: "#032D45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluefooter);
export default __webpack_public_path__ + "static/media/bluefooter.5d6d74d425c15e3c42d1016927b42f82.svg";
export { ForwardRef as ReactComponent };